import { useFormik } from 'formik';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Form, Tab, Tabs, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import CommonDropdown from '../../../sharedcomponents/CommonDropdown/CommonDropdown';
import TextFieldInput from '../../../sharedcomponents/TextFieldInput/TextFieldInput';
import { trimFormValues } from '../../../helpers';
import ManageUserIds from '../manage-user-ids/manage-user-ids';
import UserEntitlements from '../user-entitlements/user-entitlements';
import UserProductEntitlements from '../user-product-entitlements/user-product-entitlements';
import WelcomeEmails from '../welcome-emails/welcome-emails';
import {
  Endpoints,
  GenericError,
  Verbiage,
  JobTitleCollection,
  UserId,
  maxPageSize,
  ReduxAction,
  queryParamFields,
  contractTypePrimary,
  ContractDisplayOptions,
  positiveStatuses,
  ProductDeliveryPlatforms,
  ProductTypes,
  ManageEmailAlerts,
} from './../../../constants';
import smartHttp from '../../../helpers/smartHttp';
import { Notify } from './../../../sharedcomponents/Alert/Notify';
import ModalBox from './../../../sharedcomponents/modal-box/ModalBox';
import store from './../../../redux/store';
import {
  getDbConfigData,
  getSelectedContractNumbers,
} from './../../../helpers/component-helper-methods';

const AddEditUser = ({
  show,
  contracts,
  handleClose,
  editData,
  setEditData,
  getUsers,
  accounts,
  handleCloneFromEditUser,
  setCloneEntitlementData,
  contractDisplayOption,
  isViewerUser,
  isBPMReferral,
}) => {
  const [loading, setLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [contractType, setContractType] = useState('');
  const [ristrictLocation, setRistrictLocation] = useState(false);
  const [isEntitlementEnabled, setIsEntitlementEnabled] = useState(false);
  const [isProductEnabled, setIsProductEnabled] = useState(false);
  const [isUserIdEnabled, setIsUserIdEnabled] = useState(false);
  const [isWelcomeEmailsEnabled, setIsWelcomeEmailsEnabled] = useState(false);
  const [officeLocationName, setOfficeLocationName] = useState([]);
  const [jobDesignationCollection, setJobDesignationCollection] = useState({});
  const [validateEntitlementTab, setValidateEntitlementTab] = useState(false);
  const [validateEmailPreferencesTab, setValidateEmailPreferencesTab] =
    useState(false);
  const [validateManageUserIdsTab, setValidateManageUserIdsTab] =
    useState(false);
  const [initialValue, setInitialValue] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    department: '',
    jobFunction: '',
    designation: '',
    accountId: '',
    officeLocationId: '',
    officeLocationName: '',
    country: '',
    contactId: '',
    isEmailOptOut: false,
  });
  const [packageDataSet, setPackageDataSet] = useState();
  const [distributorDataSet, setDistributorDataSet] = useState();
  const [distributorEntitlementTab, setDistributorEntitlementTab] = useState();
  const [distributorToIndicate, setDistributorToIndicate] = useState();
  const [userEntitlementsData, setUserEntitlementsData] = useState([]);
  const [entitlementMappingData, setEntitlementMappingData] = useState();

  const [activeTab, setActiveTab] = useState('user-details-tab');
  const [userContractNumber, setUserContractNumber] = useState([]);
  // Holds contract metadata for the user being edited. Since the users
  // grid no longer carries `contractNumber`, `isVirtualContract`,
  // `mappedContractNumber`, we resolve them from the user API by contactId
  // and pass this object down to all edit-user tabs.
  const [userContractInfo, setUserContractInfo] = useState();
  const dispatch = useDispatch();
  const entitlementTabName = 'entitlements-tab';
  const productEntitlementTabName = 'product-entitlements-tab';
  const userIdTabName = 'manage-user-ids-tab';
  const welcomeEmailsTabName = 'welcome-emails-tab';

  useEffect(() => {
    // Controller to abort previous API calls if any ongoing flight
    const controller = new AbortController();
    const signal = controller.signal;
    (async () => {
      setEditMode(Boolean(editData));

      if (editData) {
        setInitialValue({
          firstName: editData.firstName ?? '',
          lastName: editData.lastName ?? '',
          email: editData.email ?? '',
          phone: editData.phone ?? '',
          department: editData.department ?? '',
          jobFunction: editData.jobFunction ?? '',
          designation: editData.designation ?? '',
          accountId: editData.accountId ?? '',
          officeLocationId: editData.officeLocationId ?? '',
          officeLocationName: editData.officeLocation ?? '',
          country: editData.country ?? '',
          contactId: editData.contactId ?? '',
          isEmailOptOut: editData.isEmailOptOut == 1 ? true : false,
        });
        getLocations('', signal);
        await getUserContractNumber(signal);
      } else {
        setUserContractInfo();
        setUserContractNumber([]);
        getLocations('', signal);
      }
    })();
    return () => {
      controller?.abort();
    };
  }, [editData]);

  useEffect(() => {
    // Controller to abort previous API calls if any ongoing flight
    const controller = new AbortController();
    const signal = controller.signal;
    getDeliveryPlatformData(signal);
    clearReduxStoreAddEditModal();
    return () => {
      controller?.abort();
    };
  }, []);

  useEffect(() => {
    let storeData = store.getState();
    // Retrieve contractType from storeData
    let contractType =
      storeData?.contract?.contracts && storeData.contract.contracts.length > 0
        ? storeData.contract.contracts[0]?.contractType
        : undefined;

    if (contractType) {
      setContractType(contractType);
    }
  }, [useSelector((x) => x.userContracts)]);

  const clearReduxStoreAddEditModal = () => {
    dispatch({
      type: ReduxAction.updateEntitlement,
      payload: {
        updatedEntitlements: {},
        initialEntitlements: [],
        selectedEntitlements: [],
      },
    });
    dispatch({
      type: ReduxAction.updateProductEntitlement,
      payload: {
        initialProductEntitlements: [],
        updatedProductEntitlements: [],
      },
    });
  };
  const validate = Yup.object({
    firstName: Yup.string()
      .trim()
      .max(80, 'Must be 80 characters or less')
      .required('Please enter first name to proceed')
      .matches('^[a-zA-Z ]*$', 'No numerical or symbolic values are accepted'),
    lastName: Yup.string()
      .trim()
      .max(80, 'Must be 80 characters or less')
      .required('Please enter last name to proceed')
      .matches('^[a-zA-Z ]*$', 'No numerical or symbolic values are accepted'),
    email: Yup.string()
      .max(80, 'Must be 80 characters or less')
      .required('Please enter email to proceed')
      .email('Invalid email address'),
    phone: Yup.string()
      .max(40, 'Must be 40 characters or less')
      .matches(
        '^[+]*[0-9 ()-]*$',
        'Numerical values with +, -, (, ) are accepted',
      ),
    department: Yup.string()
      .max(80, 'Must be 80 characters or less')
      .matches(
        '^[A-Za-z0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _-]*$',
        'No special characters values are accepted',
      ),
    jobFunction: Yup.string()
      .max(80, 'Must be 80 characters or less')
      .required('Please select Job function'),
    designation: Yup.string()
      .max(80, 'Must be 80 characters or less')
      .required('Please select Role'),
    accountId:
      contracts &&
      contracts.some(
        (contract) => contract.checked && contract.isVirtualContract === 1,
      )
        ? Yup.string()
        : Yup.string().required('Please select account to proceed'),
    officeLocationId: Yup.string().required(
      'Please select location to proceed',
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValue,
    validationSchema: validate,
    onSubmit: (values) => {
      AddUser(trimFormValues(values));
    },
  });
  const AccountHandler = (val, name) => {
    let obj = {
      target: { name: name, value: val[name] ?? val },
    };
    if (name == 'officeLocationId') {
      // List of restricted locations
      let restrictedLocation = jobDesignationCollection.restrictedCountries
        .split(',')
        .map((country) => country.trim().toLowerCase());

      // Get the initial location's country
      let initialCountry = initialValue?.country?.toLowerCase();

      // Get the new location's country
      let countryName = val?.country?.toLowerCase();

      if (
        restrictedLocation.includes(countryName) &&
        restrictedLocation.includes(initialCountry)
      ) {
        setRistrictLocation(false); // Both are restricted, so location is not restricted
      } else if (
        restrictedLocation.includes(countryName) ||
        restrictedLocation.includes(initialCountry)
      ) {
        setRistrictLocation(true); // Either one is restricted, so location is restricted
      } else {
        setRistrictLocation(false);
      }
    }

    formik.handleChange(obj);
    if (name === 'officeLocationId') {
      // Account is derived from Location (one-to-one in business logic),
      // so populate accountId from the chosen location row. Mirrors
      // end-user registration behaviour.
      formik.setFieldValue('accountId', val?.accountId ?? '');
    }
  };

  const getDuplicateLocationsWithContractNum = (locations) => {
    let uniqueLocations = [];
    let duplicateLocations = [];
    locations?.forEach((el) => {
      if (!uniqueLocations?.includes(el.officeLocationId)) {
        uniqueLocations?.push(el.officeLocationId);
      } else {
        duplicateLocations?.push(el.officeLocationId);
      }
    });

    // Map to new objects instead of mutating the (potentially cached) API
    // response objects in place, otherwise the contract number suffix
    // keeps getting re-appended every time this runs against the same
    // cached data (e.g. each time the modal is reopened).
    return locations?.map((el) => {
      if (duplicateLocations?.includes(el.officeLocationId)) {
        return {
          ...el,
          officeLocationName:
            el.officeLocationName + ' (' + el.contractNumber + ')',
        };
      }
      return el;
    });
  };
  // get all user entitlement mappings
  const getEntitlementMappings = () => {
    if (contracts && contracts.some((x) => x.checked)) {
      const { contractNumberFilter: selectedContractNumberFilter } =
        getSelectedContractNumbers(contracts);
      const scopedContractNumbers =
        editData?.contactId && userContractNumber?.length > 0
          ? userContractNumber
          : [];
      const contractNumberFilter = scopedContractNumbers.length
        ? scopedContractNumbers.map((num) => `"${num}"`).join(',')
        : selectedContractNumberFilter;

      if (!contractNumberFilter) {
        setEntitlementMappingData([]);
        return;
      }

      let queryParams = {
        pageSize: maxPageSize,
        Filter: `contractNumber in(${contractNumberFilter}) ${
          editData?.contactId
            ? ' AND contactid:"' + editData?.contactId + '"'
            : ''
        }`,
        Sort: 'statusSortOrder:asc,modifiedDate:desc',
      };
      smartHttp
        .get(Endpoints.userentitlementsApi, queryParams)
        .then((res) => {
          const response = res?.data?.results?.map((c, index) => {
            c.id = index;
            return c;
          });

          setEntitlementMappingData(response);
        })
        .catch((err) => {
          setEntitlementMappingData([]);
        });
    } else {
      setEntitlementMappingData([]);
    }
  };
  const getLocations = (accountId, signal) => {
    if (contracts) {
      let queryLocationParams = {
        PageSize: 5000,
        field:
          'accountId,accountName,contractNumber,officeLocationName,officeLocationId,Country,isVirtualContract,mappedContractNumber,contractType',
      };

      // Locations now drive Account selection, so load locations for all
      // checked contracts up front (no longer scoped by accountId).
      queryLocationParams.filter = `contractNumber in(${contracts
        .filter((x) => x.checked)
        .map((t) => (t.id ? '"' + t.id + '"' : ''))
        .join(',')})`;
      setOfficeLocationName();
      smartHttp
        .get(Endpoints.accountApi, queryLocationParams, {
          axiosConfig: { signal },
        })
        .then((res) => {
          if (res) {
            setOfficeLocationName(
              getDuplicateLocationsWithContractNum(res.data?.results),
            );
          }
        })
        .catch((err) => {
          setOfficeLocationName([]);
        });
    }
  };

  const getUserContractNumber = async (signal) => {
    if (!editData?.contactId) return;

    // Build the contractNumber filter from the parent contracts dropdown.
    // For virtual contracts, expand to their mapped (real) contract numbers
    // so that the user API only ever receives actual contractNumbers.
    const { contractNumbers: parentContractNumbers, contractNumberFilter } =
      getSelectedContractNumbers(contracts || []);

    if (!contractNumberFilter) {
      setUserContractInfo();
      setUserContractNumber([]);
      return;
    }

    // Fetch ALL contract rows for this user via the user API using
    // contactId + parent-selected contract numbers. The users grid no
    // longer carries contractNumber / isVirtualContract /
    // mappedContractNumber, so we resolve them here. Since one
    // contractType can now span multiple contracts for the same user, we
    // filter the response by the edited row's contractType and build a
    // list of contract numbers that all edit-user tabs operate on (works
    // uniformly for single or multiple contracts).
    const queryParams = {
      pageSize: 50,
      Field:
        'contractNumber,isVirtualContract,mappedContractNumber,contractDescription,contractType',
      filter: `contactid:"${editData?.contactId}" AND contractNumber in(${contractNumberFilter})`,
    };

    try {
      const userContractResp = await smartHttp.get(
        Endpoints.userApi,
        queryParams,
        { axiosConfig: { signal } },
      );
      const allRows = userContractResp?.data?.results || [];
      const matchedRows = editData?.contractType
        ? allRows.filter((r) => r.contractType === editData.contractType)
        : allRows;

      // Expand any virtual contracts in the response to their mapped real
      // contract numbers before storing, so downstream tabs always work
      // with actual contractNumbers (single or multiple).
      const expandedContractNumbers = [
        ...new Set(
          matchedRows.flatMap((r) => {
            if (r.isVirtualContract && r.mappedContractNumber) {
              return r.mappedContractNumber
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean);
            }
            return r.contractNumber ? [r.contractNumber] : [];
          }),
        ),
      ];

      if (expandedContractNumbers.length > 0) {
        const firstRow = matchedRows[0] || {};
        setUserContractInfo({
          contractType: editData?.contractType,
          contractNumbers: expandedContractNumbers,
          // Kept for backward compatibility with any consumers; mapped is
          // the joined list of all expanded contract numbers.
          contractNumber: firstRow.contractNumber,
          isVirtualContract: firstRow.isVirtualContract,
          mappedContractNumber: expandedContractNumbers.join(','),
          contractDescription: firstRow.contractDescription,
        });
        setUserContractNumber(expandedContractNumbers);
      } else {
        setUserContractInfo();
        setUserContractNumber([]);
      }
    } catch (err) {
      // signal aborts will throw; ignore silently
    }
  };

  const getjobFunctionDesignationData = async () => {
    try {
      let storeDBConfig = await getDbConfigData(dispatch);
      if (
        storeDBConfig?.jobFunctionCollection?.length > 0 ||
        storeDBConfig?.designationCollection?.length > 0 ||
        storeDBConfig?.restrictedCountries
      ) {
        setJobDesignationCollection(storeDBConfig);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getjobFunctionDesignationData();
  }, []);

  // populate packages for entitlements tab in User Details
  // Accepts an array of contract numbers (handles both single and multi
  // contract scenarios uniformly).
  const getAllUserEntitlements = (contractNumbersInput) => {
    const contractNumbersArr = Array.isArray(contractNumbersInput)
      ? contractNumbersInput.filter(Boolean)
      : (contractNumbersInput || '')
          .toString()
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);

    const safeContractNumbers =
      contractNumbersArr.length > 0
        ? contractNumbersArr
        : (userContractInfo?.contractNumbers || []).filter(Boolean);

    const contractNumberFilter = safeContractNumbers
      .map((num) => `"${num}"`)
      .join(',');
    const queryParams = {
      pageSize: maxPageSize,
      id: Date.now(),
      filter: `contractNumber in (${contractNumberFilter})`,
      Field:
        'packageId,packageName,componentCount,distributor,distributorId,distributorPlatform,distributorDisplayName,distributorPlatformDisplayName,deliveryType,productComponentId,contractNumber,platformCategories,userIdFormat',
    };

    const hcAccountId = contracts?.find((c) => c.checked)?.hC_AccountID;
    const mappingPromise = hcAccountId
      ? smartHttp.getRapid(Endpoints.companyDistributorMappingApi, {
          pageSize: 5000,
          filter: `hcaccountid:"${hcAccountId}" AND isdeleted:0`,
        })
      : Promise.resolve(null);

    Promise.all([
      smartHttp.get(Endpoints.contractPackagesApi, queryParams),
      mappingPromise,
    ])
      .then(([res, mappingRes]) => {
        if (!res) return;

        const results = res?.data?.results || [];

        if (!contracts?.some((x) => x.checked)) {
          setUserEntitlementsData([]);
          setPackageDataSet([]);
          setDistributorEntitlementTab([]);
          return;
        }
        const { contractNumbers, contractNumberFilter } =
          getSelectedContractNumbers(contracts);

        const mappedIds = (mappingRes?.data?.results || [])
          .map((m) => m.distributorId ?? m.distributorid)
          .filter((id) => id !== undefined && id !== null);
        const mappedIdSet = new Set(mappedIds);

        // Filter contract packages
        const filteredContractPackagesRaw = results.filter((item) =>
          userContractNumber.includes(item.contractNumber),
        );
        const filteredContractPackages =
          mappedIdSet.size > 0
            ? filteredContractPackagesRaw.filter((p) =>
                mappedIdSet.has(p.distributorId),
              )
            : filteredContractPackagesRaw;
        setUserEntitlementsData(filteredContractPackages);

        // Use the same filtered array for distributor data
        const distributorData = { results: filteredContractPackages };

        const entitlementQueryParams = {
          pageSize: maxPageSize,
          id: Date.now(),
          Field:
            'distributor,distributorId,distributorPlatform,distributorDisplayName,distributorPlatformDisplayName,deliveryType,productType',
          filter: `contractNumber in (${contractNumberFilter}) AND status IN (${positiveStatuses
            .map((s) => `"${s}"`)
            .join(',')})`,
        };
        // Retrieve matching UEs for indicator flag
        smartHttp
          .get(Endpoints.userentitlementsApi, entitlementQueryParams)
          .then((result) => {
            const userEntitlements = result?.data?.results || [];
            let productDistToIndicate = [];
            const entitlementDistributorIds = new Set(
              userEntitlements.map((el) => {
                // Check for Ent with productType Ancillary or legacy or distributor alphamail
                if (
                  ProductTypes.some((type) => type === el.productType) ||
                  ProductDeliveryPlatforms.includes(el.distributor)
                ) {
                  productDistToIndicate.push(el.distributorId);
                  return null;
                } else return el.distributorId;
              }),
            );

            setDistributorToIndicate([...new Set(productDistToIndicate)]);

            const updatedDistributorResults = distributorData.results.map(
              (platform) => ({
                ...platform,
                indicatePlatform: entitlementDistributorIds.has(
                  platform.distributorId,
                ),
              }),
            );
            setDistributorEntitlementTab({
              results: updatedDistributorResults,
            });

            // Process package data
            const uniquePackageData = [
              ...new Map(
                results
                  .filter(
                    (item) =>
                      !ProductDeliveryPlatforms.includes(item.distributor) &&
                      safeContractNumbers.includes(item.contractNumber) &&
                      (mappedIdSet.size === 0 ||
                        mappedIdSet.has(item.distributorId)),
                  )
                  .map(
                    ({
                      distributorId,
                      packageId,
                      packageName,
                      productComponentId,
                      contractNumber,
                      componentCount,
                    }) => [
                      packageId,
                      {
                        distributorId,
                        packageId,
                        packageName,
                        productComponentId,
                        contractNumber,
                        componentCount,
                      },
                    ],
                  ),
              ).values(),
            ];

            setPackageDataSet({
              metadata: { count: uniquePackageData.length },
              results: uniquePackageData,
            });
          })
          .catch(() => {
            setDistributorEntitlementTab([]);
            setPackageDataSet([]);
          });
      })
      .catch(() => {
        setUserEntitlementsData([]);
        setPackageDataSet([]);
        setDistributorEntitlementTab([]);
      });
  };

  useEffect(() => {
    if (Boolean(editData)) {
      if (JSON.stringify(initialValue) !== JSON.stringify(formik.values)) {
        setIsDirty(true);
      } else {
        setIsDirty(false);
      }
    }
  }, [formik.values]);

  const onConfirmAction = (newPostData) => {
    if (!editMode) {
      setActiveTab('entitlements-tab');
      setIsEntitlementEnabled(true);
      setEditData({ ...newPostData });
      const newContractNumbers = newPostData?.isVirtualContract
        ? (newPostData?.mappedContractNumber || '')
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean)
        : [newPostData?.contractNumber].filter(Boolean);
      getAllUserEntitlements(newContractNumbers);
      setIsDirty(false);
    }
  };

  const notifyAddEditUser = (postData, response) => {
    let notify_msg = '';
    // Custom msg on Add/Edit & API response
    switch (String(response?.code)) {
      // 0 - Data added/edited to DB
      case '0': {
        notify_msg = editMode
          ? 'User has been updated'
          : 'User details have been saved successfully';
        break;
      }
      // -2 - Duplicate email id
      case '-2': {
        notify_msg = response?.cause;
        break;
      }
      default:
        notify_msg = GenericError.somethingWentWrong;
    }

    let newPostData = {};
    if (!editMode) {
      let contractNumberFromOfficeID = officeLocationName.filter(
        (el) => el.officeLocationId === postData.officeLocationId,
      );

      const contractTypeMap = contractNumberFromOfficeID.reduce((acc, row) => {
        const typeKey = row?.contractType || '';

        if (!acc[typeKey]) {
          acc[typeKey] = {
            contractType: typeKey,
            contracts: new Set(),
          };
        }

        if (row?.isVirtualContract) {
          (row?.mappedContractNumber || '')
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean)
            .forEach((contractNumber) => {
              acc[typeKey].contracts.add(contractNumber);
            });
        } else if (row?.contractNumber) {
          acc[typeKey].contracts.add(row.contractNumber);
        }

        return acc;
      }, {});

      const contractTypeData = Object.values(contractTypeMap).map(
        ({ contractType, contracts }) => ({
          contractType,
          contracts: [...contracts],
        }),
      );

      const selectedOfficeLocation = contractNumberFromOfficeID[0] || {};

      newPostData = {
        ...postData,
        contactId: response?.results[0]?.contactId,
        contractNumber: selectedOfficeLocation?.contractNumber,
        isVirtualContract: selectedOfficeLocation?.isVirtualContract,
        mappedContractNumber: selectedOfficeLocation?.mappedContractNumber,
        contractTypeData,
      };
    }

    // Notify config to show conditional alert after adding new user
    let notifyConfig = {
      confirmBtnText: 'Add entitlements',
      onConfirm: () => onConfirmAction(newPostData),
      cancelBtnText: 'Close',
      onCancel: () => onAddEditModalClose(),
      secondBtnText: 'Clone entitlements',
      onSecondAction: () => handleCloneEntitlement(newPostData),
      showCloseBtn: false,
    };
    Notify({
      alert: true,
      type: 'success',
      title: notify_msg,
      dialogClassName: !editMode ? 'alert-max-width' : '',
      ...(!editMode && notifyConfig),
    });
  };

  const handleCloneEntitlement = (newPostData) => {
    setCloneEntitlementData(newPostData);
    handleCloneFromEditUser(newPostData);
    onAddEditModalClose();
  };

  const AddUser = (userDetails) => {
    if (ristrictLocation && editMode) {
      Notify({
        alert: true,
        type: 'error',
        title:
          'The location you are trying to update is restricted. Please reach out to CI Support for assistance',
      });
    } else {
      setLoading(true);
      let User_Info = {
        userid: UserId,
        isDeleted: 0,
        ...userDetails,
      };
      User_Info.contactId = editMode ? editData?.contactId : '-1';
      User_Info.isEmailOptOut = User_Info.isEmailOptOut ? 1 : 0;
      if (editMode) {
        User_Info.email = editData?.email;
      }
      // On New User addition, if contractType is not present in userDetails, get it from location
      if (!editMode && !User_Info.contractType) {
        const location = officeLocationName?.find(
          (el) => el.officeLocationId === userDetails.officeLocationId,
        );
        User_Info.contractType =
          User_Info.contractType || location?.contractType || '';
      }

      let postData = {};
      for (let key in User_Info) {
        if (typeof User_Info[key] === 'string') {
          postData[key] = User_Info[key].trim();
        } else {
          postData[key] = User_Info[key];
        }
      }
      smartHttp
        .post(Endpoints.userApi, [postData])
        .then((resp) => {
          if (resp?.data?.code === 0) {
            getUsers();
            notifyAddEditUser(postData, resp.data);
            editMode && onAddEditModalClose();
          }
        })
        .catch((err) => {
          let errorMsg =
            err?.response?.data?.resultCode === '-2' ||
            err?.response?.data?.resultCode === '-3'
              ? err?.response?.data?.cause
              : GenericError.somethingWentWrong;
          Notify({
            alert: true,
            type: 'error',
            title: errorMsg,
          });
        })
        .finally(() => setLoading(false));
    }
  };

  const onAddEditModalClose = async () => {
    await setInitialValue({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      department: '',
      jobFunction: '',
      designation: '',
      accountId: '',
      officeLocationId: '',
      groupName: '',
    });
    setEditData();
    handleClose();
  };
  const getDeliveryPlatformData = (signal) => {
    let storeData = store.getState();
    let storeDistributors = storeData?.distributors;
    if (storeDistributors?.userDistributors) {
      setDistributorDataSet(storeDistributors.userDistributors);
    } else {
      let queryParams = {
        pageSize: maxPageSize,
        Field: queryParamFields.contractPackagesAPIFields,
      };
      smartHttp
        .get(Endpoints.contractPackagesApi, queryParams, {
          axiosConfig: { signal },
        })
        .then((res) => {
          if (res) {
            let distributorData = res.data?.results.map(
              ({
                distributor,
                distributorDisplayName,
                distributorId,
                distributorPlatform,
                distributorPlatformDisplayName,
                deliveryType,
                packageId,
                productComponentId,
                platformCategories,
                userIdFormat,
              }) => ({
                distributor,
                distributorDisplayName,
                distributorId,
                distributorPlatform,
                distributorPlatformDisplayName,
                deliveryType,
                packageId,
                productComponentId,
                platformCategories,
                userIdFormat,
              }),
            );
            distributorData = distributorData.filter(
              (e, i) =>
                distributorData.findIndex(
                  (a) => a['distributorId'] === e['distributorId'],
                ) === i,
            );
            let metadata = res?.data?.metadata;
            metadata.count = distributorData?.length;
            let finalDistributorData = [];
            finalDistributorData.metadata = metadata;
            finalDistributorData.results = distributorData;
            setDistributorDataSet(finalDistributorData);
            dispatch({
              type: ReduxAction.distributors,
              payload: {
                distributors: finalDistributorData,
              },
            });
          }
        })
        .catch((err) => {
          setDistributorDataSet([]);
        });
    }
  };

  const updateEntitlementsChanged = (value) => {
    setValidateEntitlementTab(value);
  };

  const updateEmailPreferencesChanged = (value) => {
    setValidateEmailPreferencesTab(value);
  };

  const updateManageUserIdsChanged = (value) => {
    setValidateManageUserIdsTab(value);
  };

  // Show confirm dialog if dirty and switching tabs
  const handleTabSelect = (key) => {
    if (
      (isDirty ||
        validateEntitlementTab ||
        validateEmailPreferencesTab ||
        validateManageUserIdsTab) &&
      !isViewerUser &&
      key !== activeTab
    ) {
      Notify({
        alert: true,
        type: 'warning',
        confirmBtnText: 'OK',
        title: 'Please update your changes before moving ahead',
        onConfirm: () => {
          setActiveTab(activeTab); // Go back to previous tab
        },
      });
    } else {
      switch (key) {
        case entitlementTabName:
          setIsEntitlementEnabled(true);
          break;
        case productEntitlementTabName:
          setIsEntitlementEnabled(true);
          setIsProductEnabled(true);
          break;
        case userIdTabName:
          setIsEntitlementEnabled(true);
          setIsProductEnabled(true);
          setIsUserIdEnabled(true);
          break;
        case welcomeEmailsTabName:
          setIsEntitlementEnabled(true);
          setIsProductEnabled(true);
          setIsUserIdEnabled(true);
          setIsWelcomeEmailsEnabled(true);
          break;
      }
      setActiveTab(key);
    }
  };

  return (
    <>
      <ModalBox
        backdrop="static"
        show={show}
        size="xl"
        contentClassName="modal-height-fix add-edit-user-modal-height-fix"
        handleClose={onAddEditModalClose}
        showLoader={loading}
        modalTitle={
          editMode ? (
            <>
              {initialValue.firstName} {initialValue.lastName}
            </>
          ) : (
            'Add a New User'
          )
        }
      >
        <div className="tabs-main mt-0">
          <Tabs
            fill
            justify
            defaultActiveKey="user-details-tab"
            activeKey={activeTab}
            onSelect={handleTabSelect}
          >
            <Tab eventKey="user-details-tab" title="User Details">
              <Container className="pt-2 user-details-tab-container">
                <Form
                  className="user-details-tab-form"
                  onSubmit={formik.handleSubmit}
                >
                  <div className="row user-details-fields">
                    <TextFieldInput
                      formLabel="First name"
                      placeholder="First name"
                      id="firstName"
                      {...formik.getFieldProps('firstName')}
                      formik={formik}
                      addAsterisk
                      autoFocus
                    />
                    <TextFieldInput
                      formLabel="Last name"
                      placeholder="Last name"
                      id="lastName"
                      {...formik.getFieldProps('lastName')}
                      formik={formik}
                      addAsterisk
                    />
                    <TextFieldInput
                      formLabel="Email"
                      placeholder="Email address"
                      id="email"
                      disabled={editMode}
                      {...formik.getFieldProps('email')}
                      formik={formik}
                      addAsterisk
                    />
                    <CommonDropdown
                      mode="single"
                      enableSearch={true}
                      searchKeys={['officeLocationName']}
                      formLabel="Location"
                      {...formik.getFieldProps('officeLocationId')}
                      name="officeLocationId"
                      options={officeLocationName}
                      formik={formik}
                      ddPlaceHolder={
                        formik.values.officeLocationId !== '' &&
                        officeLocationName?.length > 0
                          ? officeLocationName?.filter(
                              (el) =>
                                el.officeLocationId ===
                                formik.values.officeLocationId,
                            )[0]?.officeLocationName
                          : 'Select'
                      }
                      labelKeyName="officeLocationName"
                      ddName="officeLocation"
                      onChangeHandler={(option) =>
                        AccountHandler(option, 'officeLocationId')
                      }
                      addAsterisk
                    />
                    {contracts &&
                      !contracts.some(
                        (contract) =>
                          contract.checked && contract.isVirtualContract === 1,
                      ) && (
                        <CommonDropdown
                          mode="single"
                          enableSearch={true}
                          searchKeys={['accountName']}
                          formLabel="Account"
                          name="accountId"
                          options={accounts}
                          formik={formik}
                          ddPlaceHolder={
                            formik.values.accountId !== '' &&
                            accounts?.length > 0
                              ? accounts?.filter(
                                  (el) =>
                                    el.accountId === formik.values.accountId,
                                )[0]?.accountName
                              : 'Select'
                          }
                          labelKeyName="accountName"
                          ddName="account"
                          onChangeHandler={(e) =>
                            AccountHandler(e, 'accountId')
                          }
                          disabled={true}
                          addAsterisk
                        />
                      )}
                    <CommonDropdown
                      mode="single"
                      enableSearch={true}
                      searchKeys={[]}
                      formLabel="Job function"
                      {...formik.getFieldProps('jobFunction')}
                      name="jobFunction"
                      options={jobDesignationCollection.jobFunctionCollection}
                      formik={formik}
                      ddPlaceHolder={
                        formik.values.jobFunction !== ''
                          ? formik.values.jobFunction
                          : 'Select'
                      }
                      ddName="jobFunction"
                      onChangeHandler={(option) =>
                        AccountHandler(option, 'jobFunction')
                      }
                      addAsterisk
                    />
                    <CommonDropdown
                      mode="single"
                      enableSearch={true}
                      formLabel="Role"
                      {...formik.getFieldProps('designation')}
                      name="designation"
                      options={jobDesignationCollection.designationCollection}
                      formik={formik}
                      ddPlaceHolder={
                        formik.values.designation !== ''
                          ? formik.values.designation
                          : 'Select'
                      }
                      ddName="designation"
                      onChangeHandler={(e) => AccountHandler(e, 'designation')}
                      addAsterisk
                    />
                    <TextFieldInput
                      formLabel="Department"
                      placeholder="Department"
                      id="department"
                      {...formik.getFieldProps('department')}
                      formik={formik}
                    />
                    <TextFieldInput
                      formLabel="Business Phone number"
                      placeholder="Business Phone number"
                      id="phone"
                      {...formik.getFieldProps('phone')}
                      formik={formik}
                    />

                    {editData?.groupName && (
                      <TextFieldInput
                        formLabel="Group Name"
                        placeholder="Group Name"
                        id="groupName"
                        disabled={true}
                        value={editData?.groupName}
                      />
                    )}
                  </div>
                  <div className="user-details-fix d-flex mt-4">
                    <Form.Group className={'col-11'}>
                      {/* Commented out Marketing Email Opt-Out as don't require this for now */}
                      {/* <Form.Check
                        type="checkbox"
                        className={''}
                        {...formik.getFieldProps('isEmailOptOut')}
                        formik={formik}
                      >
                        <Form.Check.Input
                          type={'checkbox'}
                          id="notificationOptIn"
                          {...formik.getFieldProps('isEmailOptOut')}
                          formik={formik}
                          checked={formik?.values?.isEmailOptOut}
                        />
                        <Form.Check.Label>
                          <div className="market-email-label label-mt-2 d-flex">
                            <span className="text-nowrap me-2">
                              Marketing Email Opt-Out :
                            </span>
                            <span>
                              You will not receive S&P Global Commodity Insights
                              promotional emails,such as insightful content,
                              event invitations and product information.
                            </span>
                          </div>
                        </Form.Check.Label>
                      </Form.Check> */}
                      {!isViewerUser && (
                        <div className="market-email-label label-mt-2">
                          <a
                            href={ManageEmailAlerts.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="manage-email-alert-link"
                          >
                            {ManageEmailAlerts.linkText}
                          </a>
                          {ManageEmailAlerts.plainText}
                        </div>
                      )}
                    </Form.Group>
                    <Form.Group className="col-1 user-save-btn-body align-items-start">
                      <button
                        disabled={!isDirty || isViewerUser}
                        type="Submit"
                        className="user-save-btn btn btn-dark float-end btn-opacity"
                      >
                        {editMode ? 'Update' : 'Save'}
                      </button>
                    </Form.Group>
                  </div>
                </Form>
              </Container>
            </Tab>
            <Tab
              eventKey="entitlements-tab"
              title="Entitlements"
              disabled={!editMode}
            >
              {editMode && isEntitlementEnabled && (
                <UserEntitlements
                  editMode={editMode}
                  editData={editData}
                  distributorDataSet={distributorEntitlementTab}
                  entitlementMappingData={entitlementMappingData}
                  getEntitlementMappings={getEntitlementMappings}
                  getUsers={getUsers}
                  onAddEditModalClose={onAddEditModalClose}
                  formik={formik}
                  initialValue={initialValue}
                  userEntitlementsData={userEntitlementsData}
                  packageDataSet={packageDataSet}
                  getAllUserEntitlements={getAllUserEntitlements}
                  setLoading={setLoading}
                  setActiveTab={setActiveTab}
                  setIsUserIdEnabled={setIsUserIdEnabled}
                  isViewerUser={isViewerUser}
                  userContractNumber={userContractNumber}
                  userContractInfo={userContractInfo}
                  updateEntitlementsChanged={updateEntitlementsChanged}
                  isBPMReferral={isBPMReferral}
                ></UserEntitlements>
              )}
            </Tab>
            <Tab
              eventKey="product-entitlements-tab"
              title="Email Preferences" // FEATURE DISABLED (Release july-2026) - was: "Product / Email Preferences"
              disabled={!editMode}
            >
              {editMode && isProductEnabled && (
                <UserProductEntitlements
                  contractNumber={userContractInfo?.contractNumber}
                  editMode={editMode}
                  distributorDataSet={distributorDataSet}
                  userEntitlementData={entitlementMappingData}
                  packageMappingData={userEntitlementsData}
                  editData={editData}
                  getUsers={getUsers}
                  onAddEditModalClose={onAddEditModalClose}
                  setLoading={setLoading}
                  setActiveTab={setActiveTab}
                  setIsUserIdEnabled={setIsUserIdEnabled}
                  isViewerUser={isViewerUser}
                  userContractNumber={userContractNumber}
                  userContractInfo={userContractInfo}
                  updateEmailPreferencesChanged={updateEmailPreferencesChanged}
                  distributorToIndicate={distributorToIndicate}
                  isBPMReferral={isBPMReferral}
                ></UserProductEntitlements>
              )}
            </Tab>
            {/* Manage User IDs */}
            {
              // Check if the CCA, CSA and End user is not a primary user
              ((editData &&
                !(editData?.contractType === contractTypePrimary)) ||
                (contractType && !(contractType === contractTypePrimary))) && (
                <Tab
                  eventKey="manage-user-ids-tab"
                  title="Manage User IDs"
                  disabled={!editMode}
                >
                  {editMode && isUserIdEnabled && (
                    <ManageUserIds
                      editMode={editMode}
                      distributorDataSet={distributorDataSet}
                      editData={editData}
                      getUsers={getUsers}
                      onAddEditModalClose={onAddEditModalClose}
                      setLoading={setLoading}
                      isEndUser={false}
                      isViewerUser={isViewerUser}
                      updateManageUserIdsChanged={updateManageUserIdsChanged}
                    ></ManageUserIds>
                  )}
                </Tab>
              )
            }
            <Tab
              eventKey="welcome-emails-tab"
              title="Welcome Emails"
              disabled={!editMode}
            >
              {editMode && isWelcomeEmailsEnabled && (
                <WelcomeEmails
                  editMode={editMode}
                  editData={editData}
                  onAddEditModalClose={onAddEditModalClose}
                  setLoading={setLoading}
                  isViewerUser={isViewerUser}
                ></WelcomeEmails>
              )}
            </Tab>
          </Tabs>
        </div>
      </ModalBox>
    </>
  );
};

export default memo(AddEditUser);
